export const LOCAL_STORAGE_ORIGIN_LOCATION_KEY = 'DID_MOBILE_ORIGIN_LOCATION';
export const LOCAL_STORAGE_PARKING_LOCATION_KEY = 'DID_MOBILE_MY_PARKING_LOCATION';
export const LOCAL_STORAGE_BOOKMARK_KEY = 'DID_MOBILE_BOOKMARK_LIST';
export const LOCAL_STORAGE_MOTION_PERMISSION_KEY = 'DID_MOBILE_MOTION_PERMISSION';
